import { firestoreToDateTime } from "@/lib/utils";
import { ColumnDef } from "@tanstack/react-table";
import { Fragment, ReactNode } from "react";
import { Technician } from "@/models";
import { HeaderSortable } from "@/components/datatables/HeaderSortable";

interface TechniciansColumnProps {
  actions: (technician: Technician) => ReactNode[];
}

const createTechniciansActionsColumn = ({
  actions,
}: TechniciansColumnProps): ColumnDef<Technician> => ({
  accessorKey: "actions",
  header: "",
  cell: ({ row }) => {
    const item = row.original;
    return (
      <div className="flex gap-2">
        {actions(item).map((action, index) => (
          <Fragment key={`action-${item.id}-${index}`}>{action}</Fragment>
        ))}
      </div>
    );
  },
});

const technicianColumns = (props?: TechniciansColumnProps) => {
  const col: ColumnDef<Technician>[] = [
    {
      accessorKey: "id",
      header: "ID",
    },
    {
      accessorKey: "firstName",
      header: ({ column }) => (
        <HeaderSortable column={column} title={"First Name"} />
      ),
    },
    {
      accessorKey: "lastName",
      header: ({ column }) => (
        <HeaderSortable column={column} title={"Last Name"} />
      ),
    },
    {
      accessorKey: "createdAt",
      header: ({ column }) => (
        <HeaderSortable column={column} title={"Created At"} />
      ),
      cell: ({ row }) => {
        const item = row.original;
        return item.createdAt
          ? firestoreToDateTime(item.createdAt)?.toLocaleString()
          : "Unknown";
      },
    },
  ];

  if (props) {
    col.push(createTechniciansActionsColumn(props));
  }
  return col;
};

export { technicianColumns };
